import type { Command } from 'commander';
import { Logger } from '@gitlab-org/logging';
import { MarketplaceRegistry } from '@gitlab-org/duo-plugin-marketplace/node';
import type { DuoCommand } from '../../duo_command';
import { ExitHandler } from '../../../utils/exit';
import type { PluginContainerProvider } from '../plugin_services';
import { formatMarketplaceShow } from './format_marketplace_show';

export class MarketplaceShowCommand implements DuoCommand {
  readonly name = 'show <name>';

  readonly description = 'Show the plugins a marketplace offers.';

  readonly #containerProvider: PluginContainerProvider;

  constructor(containerProvider: PluginContainerProvider) {
    this.#containerProvider = containerProvider;
  }

  register(node: Command): void {
    node.action(async (name: string) => {
      const registry = this.#containerProvider.getRequiredService(MarketplaceRegistry, node);

      try {
        const plugins = await registry.show(name);
        // eslint-disable-next-line no-console
        console.log(formatMarketplaceShow(name, plugins));
      } catch (e) {
        const logger = this.#containerProvider.getRequiredService(Logger, node);
        logger.error('Failed to show marketplace', e instanceof Error ? e : new Error(String(e)));
        const message = e instanceof Error ? e.message : String(e);
        // eslint-disable-next-line no-console
        console.error(`Failed to show marketplace: ${message}`);
        await this.#containerProvider.getRequiredService(ExitHandler, node).exit(1);
      }
    });
  }
}
